import type { HTMLImgProps } from '../../types'

interface ThumbnailPropsBase {
  className?: string
  size?: ThumbnailSizeType
  ratio?: ThumbnailRatioType
}

export type ThumbnailProps = ThumbnailPropsBase & HTMLImgProps

export enum ThumbnailRatio {
  ratio1x1 = '1x1',
  ratio4x3 = '4x3',
  ratio1xFill = '1xfill',
  ratio9x16 = '9x16',
  ratio4x5 = '4x5',
  ratio16x9 = '16x9',
  ratioFillx1 = 'fillx1',
}

export enum ThumbnailSize {
  xxxsmall = 'xxxs',
  xxsmall = 'xxs',
  xsmall = 'xs',
  small = 's',
  medium = 'm',
  large = 'l',
  xlarge = 'xl',
  xxlarge = 'xxl',
}

export type ThumbnailRatioType = `${ThumbnailRatio}`
export type ThumbnailSizeType = `${ThumbnailSize}`
